export default __webpack_public_path__ + "static/media/Asr.b705d2f4.mp3";